import { Box, Button, Grid, Tab, Tabs } from "@mui/material";
import { Buffer } from "buffer";
import saveAs from "file-saver";
import React, { useState } from "react";
import { LoggedInSkeleton } from "src/Components/Common/LoggedInSkeleton";
import useFetch from "src/Components/Common/useFetch";
import { a11yProps, TabPanel } from "src/Components/Recon360/ReconSettings/ReconSettings";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";

const TaskManagementAnalytics = () => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <LoggedInSkeleton topBarButtons={[]}>
      <div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Recon Tasks" {...a11yProps(0)} sx={{ textTransform: "none" }} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} key={0}>
            <ReconTasks />
          </TabPanel>
        </Box>
      </div>
    </LoggedInSkeleton>
  );
};

export const ReconTasks = () => {
  const [downloadingTasks, setDownloadingTasks] = useState(false);
  const downloadReconTasks = () => {
    setDownloadingTasks(true);
    useFetch(API_ENDPOINTS.GET_TASKS_REPORT.url, "GET", {
      failureMessage: API_ENDPOINTS.GET_TASKS_REPORT.failureMessage,
      showSuccessToast: true,
      thenCallBack: (res) => {
        const { excelBuffer, filename } = res.data;

        const excelData = Buffer.from(excelBuffer, "base64");
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([excelData], { type: fileType });

        saveAs(blob, filename);
        setDownloadingTasks(false);
      },
      catchCallBack: () => {
        setDownloadingTasks(false);
      },
    });
  };

  return (
    <Grid className="center_align fade_in">
      <Button
        variant="contained"
        className="theme_btn"
        sx={{
          m: "30px",
        }}
        onClick={() => downloadReconTasks()}
        disabled={downloadingTasks}
      >
        {downloadingTasks ? (
          <span className="file-icon">
            <i className="fas fa-circle-notch fa-spin" />
          </span>
        ) : null}
        Download Recon Tasks
      </Button>
    </Grid>
  );
};

export default TaskManagementAnalytics;
